module.exports = __webpack_public_path__ + "static/media/company_5.png";